import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Button, Badge, Modal, ModalBody, Row, Col } from "reactstrap";
import Title from "../title";
import { ComonIcons } from "../../contents/commonIcons";
import TypeScheduleTabs from "./typesScdule";
import moment from "moment";
import Swal from "sweetalert2";
import { changeSchedulePublishStatus } from "../../redux/actions/api/apiAction";

const DateIntervalSummary = ({
  setDateIntervals,
  dateIntervals,
  setDeletedDateIntervals,
  deletedDateIntervals,
  setCurrentUdatedInterval,
  setShowUpdateModal,
  setIntialUpdatedInterval,
}) => {
  const { slotsTypes,court } = useSelector((state) => state.court);
  const {gym } = useSelector((state) => state.gym);
  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };
  const dispatch=useDispatch()

  const formatTimeSlots = (input) => {
    // Check if input is a simple timeSlots object (has day keys directly)
    const isSimpleTimeSlots =
      input &&
      typeof input === "object" &&
      [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ].some((day) => input[day]?.length >= 0);

    // Handle all cases
    const slotsData =
      !input || Object.keys(input).length === 0
        ? { default: {} } // null, undefined, empty object
        : isSimpleTimeSlots
        ? { default: input } // direct timeSlots format
        : input.timeSlots // has both timeSlots and timeSlotsByType
        ? { default: input.timeSlots, ...(input.timeSlotsByType || {}) }
        : input.timeSlotsByType || input; // only timeSlotsByType or already correct format

    return Object.entries(slotsData)
      .map(([type, slots]) => {
        const activeDays = Object.entries(slots || {})
          .filter(([_, timeSlots]) => timeSlots?.length > 0)
          .map(([day, timeSlots]) => ({
            day,
            count: timeSlots.length,
            slots: timeSlots,
          }));

        if (activeDays.length === 0) return null;

        return (
          <div key={type} className="mb-2">
            <Badge
              color={type == 1 ? "info" : "warning"}
              className="mb-1"
              style={{ fontSize: "0.9em" }}
            >
              {type === "default"
                ? "SLOTS"
                : slotsTypes
                    .find((slot) => slot.id == type)
                    ?.name?.toUpperCase() || ""}
            </Badge>
            <div className="d-flex flex-wrap gap-2 mt-1">
              {activeDays.map(({ day, count, slots }) => (
                <div
                  key={day}
                  className="border rounded p-2 bg-light"
                  style={{ fontSize: "0.9em" }}
                >
                  <strong>{day}</strong>
                  <div>
                    {slots.map((slot, idx) => (
                      <div key={idx} className="text-muted">
                        {slot.start} - {slot.end}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })
      .filter(Boolean); // Remove null entries
  };
  const tableStyles = {
    table: {
      borderCollapse: "collapse",
      width: "100%",
    },
    th: {
      border: "1px solid #dee2e6",
      padding: "0.75rem",
      backgroundColor: "#6c757d",
      color: "white",
    },
    td: {
      border: "1px solid #dee2e6",
      padding: "0.75rem",
      verticalAlign: "top",
    },
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-5 mb-3 ">
        <h5 className="mb-0">Date Interval Summary</h5>
      </div>
       <div style={{ display: "flex", gap: "1rem", margin: "1rem 0" }}>
       <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <div
            style={{
              width: "20px",
              height: "20px",
              backgroundColor: "white", // soft cyan for workshops
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
          <span> {gym?.type == "sportClub" ? "Reserved for Rental Court / Private Lesson " : "Reserved for Booking Room"}</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <div
            style={{
              width: "20px",
              height: "20px",
              backgroundColor: "#e6f7ff", // 
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
          <span> {gym?.type == "sportClub" ? "Reserved for Group Session" : "Reserved for  Class"}</span>
        </div>
      </div>
      <Table responsive style={tableStyles.table} >
        <thead>
          <tr>
            <th style={{ ...tableStyles.th, width: "30%" }}>Date Interval</th>
            <th style={{ ...tableStyles.th, width: "60%" }}>Time Slots</th>
            <th style={{ ...tableStyles.th, width: "10%" }}></th>
          </tr>
        </thead>
        <tbody>
          {dateIntervals.map((interval, index) => (
            <tr key={index}
              style={{
                backgroundColor:
                  interval.type === "onlyCourt"
                    ? "white" // light blue
                    : interval.type === "groupSession"
                    ? "#e6f7ff" // light orange
                    : "transparent",
              }}
            >
              <td style={tableStyles.td}>
                {moment(interval?.startDate).format("DD/MM/YYYY")}-{" "}
                {moment(interval?.endDate).format("DD/MM/YYYY")}
              </td>
              <td style={tableStyles.td}>
                {formatTimeSlots(
                  interval.timeSlots &&
                    (Array.isArray(interval.timeSlots)
                      ? interval.timeSlots.length > 0
                      : Object.keys(interval.timeSlots).length > 0)
                    ? interval.timeSlots
                    : interval.timeSlotsByType
                )}
              </td>
              
              <td style={tableStyles.td} className=" date-interval-summary text-center">
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn-action btn-delete"
                      onClick={() => {
                      const deletedIntervals = dateIntervals.filter(
                        (_, i) => i == index
                      );
                      setDeletedDateIntervals([
                        ...deletedDateIntervals,
                        ...deletedIntervals,
                      ]);
                      const updatedIntervals = dateIntervals.filter(
                        (_, i) => i !== index
                      );
                      setDateIntervals(updatedIntervals);
                    }}
                    >
                      Delete
                    </button>
                    <button
                      type="button"
                      className="btn-action btn-update"
                       onClick={() => {
                      setShowUpdateModal(true);
                      setCurrentUdatedInterval(interval);
                      setIntialUpdatedInterval(interval);
                    }}
                    >
                      Update
                    </button>
                  {
                    interval?.type !=="groupSession" && court &&court?.id &&
                    <button
                      type="button"
                      className={`btn-action ${
                        interval?.isPublished ? "btn-unpublish" : "btn-publish"
                      }`}
                    onClick={() => {
                     Swal.fire({
                        title: "Confirm",
                        text: `Are you sure you want to ${interval?.isPublished?"Un Publish":"Publish"} interval schedule?`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#4D4467",
                        cancelButtonColor: "#d33",
                        confirmButtonText: `Yes, ${interval?.isPublished?"Un Publish":"Publish"} it!`,
                      }).then(async (result) => {
                        if (result.isConfirmed) {
                          console.log({interval})
                          const allSlotIds = interval.timeSlots
                            ? Array.isArray(interval.timeSlots)
                              ? interval.timeSlots.map(s => s.id)
                              : Object.values(interval.timeSlots).flat().map(s => s.id)
                            : interval.timeSlotsByType
                            ? Object.values(interval.timeSlotsByType || {})
                              .flatMap(dayObj => Object.values(dayObj).flat()) // flatten second level
                              .filter(Boolean)
                              .map(slot => slot.id)
                            : [];

                           dispatch(changeSchedulePublishStatus({ids:allSlotIds,court:court.id,isPublished:!interval?.isPublished}));
                        }
                      });
                    }}
                    >
                      {interval?.isPublished ? "Unpublish" : "Publish"}
                    </button>
                  }

                  </div>
                </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default DateIntervalSummary;
